import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useOrderLeadTime from '@hooks/useOrderLeadTime'
import useOrderLeadTimes from '@hooks/useOrderLeadTimes'
import useServices from '@hooks/useServices'

import OrderLeadTimeGroup from './OrderLeadTimeGroup'

const OrderLeadTimes = (props) => {
  const { providerId } = props

  const options = {
    filters: { provider_id: providerId },
    performHttpRequests: !!providerId,
  }

  const orderLeadTimesPayload = useOrderLeadTimes(options)
  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredOrderLeadTimesCount,
    groupedOrderLeadTimes,
    hasFilteredOrderLeadTimes,
    loading,
  } = orderLeadTimesPayload

  const servicesPayload = useServices()
  const { filteredServices } = servicesPayload

  const {
    callbacks: { createOrEditOrderLeadTime },
  } = useOrderLeadTime({ provider_id: providerId })

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-lead-times' }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Lead Times"
    >
      {!loading && !hasFilteredOrderLeadTimes && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Lead Times present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please create one below.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.ScrollableSection>
        {hasFilteredOrderLeadTimes && filteredServices.map((service) => {
          if (groupedOrderLeadTimes[service.id]){
            return (
              <OrderLeadTimeGroup
                key={service.id}
                orderLeadTimesGroup={groupedOrderLeadTimes[service.id]}
                providerId={providerId}
                service={service}
              />
            )
          }

          return null
        })}
      </DashboardModule.ScrollableSection>

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredOrderLeadTimesCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => createOrEditOrderLeadTime()}
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Lead Time
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

OrderLeadTimes.propTypes = {
  providerId: PropTypes.number.isRequired,
}

export default OrderLeadTimes
